import React, { Fragment, useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { Link, useLocation, useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import * as constants from "../../../utils/Constants";
import { CircularProgress } from "@mui/material";

const Profile = () => {
  const [existingInvoice, setExistingInvoice] = useState({});
  const [error, setError] = useState(null);
  const [acceptedCtc, setAcceptedCtc] = useState(0);
  const [ctcPercent, setCtcPercent] = useState(0);
  const [ctcDetails, setCtcDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [statusHistory, setStatusHistory] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSpin, setIsSpin] = useState(false);
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const statusUrl =
    loggedInUser.roles === "Admin"
      ? constants.ListStatusUrl
      : loggedInUser.roles === "Accountant"
      ? constants.ListStatusForAccountantUrl
      : loggedInUser.roles === "Internal Recruiter"
      ? constants.ListStatusForIRUrl
      : constants.ListStatusUrl;

  const history = useHistory();
  const [status, setStatus] = useState({
    statusName: "",
    statusComment: "",
  });
  const [progressList, setProgressList] = useState([]);
  const [progress, setProgress] = useState("");
  const {
    state,
    filterDataCallback,
    searchCallBack,
    sortByCallBack,
    orderCallBack,
    pageCallBack,
  } = useLocation();
  const backBtn = () => {
    let backPage =
      loggedInUser.roles === "Accountant" ? "/list-invoice" : "/list-candidate";
    history.push({
      pathname:
        loggedInUser.roles === "Accountant"
          ? "/list-invoice"
          : "/list-candidate",
      state: "",
      filterDataCallback: filterDataCallback,
      searchCallBack: searchCallBack,
      sortByCallBack: sortByCallBack,
      orderCallBack: orderCallBack,
      pageCallBack: pageCallBack,
    });
  };
  const classNames = [
    "timeline-badge primary",
    "timeline-badge info",
    "timeline-badge danger",
    "timeline-badge success",
    "timeline-badge warning",
    "timeline-badge dark",
  ];

  const handleComments = (e) => {
    status.statusComment = e.target.value;
  };

  const handleBlur = (e) => {
    const newCtcDetails = { ...ctcDetails };
    newCtcDetails[e.target.name] = parseFloat(e.target.value);
    setCtcDetails(newCtcDetails);
  };

  const saveComments = () => {
    setIsSpin(true);
    fetch(`${constants.UpdateStatusUrl}/${state.applyJobId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify(status),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          toast.success(`✅ ${res.message.messageDescription} !`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          const updatedStatusHistory = [
            ...(statusHistory || []),
            {
              statusChangedDate: new Date(),
              statusName: status.statusName,
              comment: status.statusComment,
            },
          ];
          setStatusHistory(updatedStatusHistory);
          setTimeout(() => {
            setIsSpin(false);
          }, 3000);
        } else {
          toast.error(`❌ ${res.error?.errorMessage}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setTimeout(() => {
            setIsSpin(false);
          }, 3000);
        }
      });
  };

  function getExisitingInvoiceDetails() {
    var url = `${constants.GenerateInvoiceUrl}/${state.agentUniqueId}`;
    var requestBody = {
      applyJobId: state.applyJobId,
    };
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.data) {
          setAcceptedCtc(0);
          setCtcPercent(0);
          setExistingInvoice(res.data);
        } else {
          if (loggedInUser.roles === "Recruitment Agent") {
            toast.error(`❌ ${res.error?.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIsSpin(false);
            }, 3000);
          }
        }
      });
  }

  const viewInvoice = () => {
    var url = `${constants.GenerateInvoiceUrl}/${state.agentUniqueId}`;
    var requestBody = {
      applyJobId: state.applyJobId,
    };
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.data) {
          setAcceptedCtc(0);
          setCtcPercent(0);
          history.push({
            pathname: "/download-invoice",
            state: res.data,
          });
        } else {
          toast.error(`❌ ${res.error?.errorMessage} !`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setTimeout(() => {
            setIsSpin(false);
          }, 3000);
        }
      });
  };

  const submitHandler = () => {
    setIsSpin(true);
    let requestBody = {};
    let url = "";
    if (loggedInUser.roles === "Recruitment Agent") {
      url = `${constants.GenerateInvoiceUrl}/${state.agentUniqueId}`;
      requestBody = {
        applyJobId: state.applyJobId,
      };
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(requestBody),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.data) {
            setAcceptedCtc(0);
            setCtcPercent(0);
            history.push({
              pathname: "/download-invoice",
              state: res.data,
            });
          } else {
            toast.error(`❌ ${res.error?.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIsSpin(false);
            }, 3000);
          }
        });
    } else if (loggedInUser.roles === "Admin") {
      if (acceptedCtc) {
        url = `${constants.GetInvoiceDetailsUrl}/${state.agentUniqueId}`;
        requestBody = {
          acceptedCTC: acceptedCtc,
          percentOfCTC: state?.commissionForJob,
          jobValue:
            parseFloat(acceptedCtc) *
            (parseFloat(state?.commissionForJob) / 100),
          applyJobId: state.applyJobId,
        };

        fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${loggedInUser.sessionToken}`,
          },
          body: JSON.stringify(requestBody),
        })
          .then((response) => response.json())
          .then((res) => {
            if (res.message) {
              toast.success(`✅ ${res.message.messageDescription} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setTimeout(() => {
                setIsSpin(false);
              }, 3000);
            } else {
              toast.error(`❌ ${res.error?.errorMessage}!`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setTimeout(() => {
                setIsSpin(false);
              }, 3000);
            }
          });
      } else {
        toast.error(`❌ Please enter CTC and % of CTC`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          setIsSpin(false);
        }, 3000);
      }
    }
    setIsModalOpen(false);
  };

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  const handleProgress = (key, event) => {
    setProgress(key);
    status.statusName = key;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(statusUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        setProgressList(res.data);
        if (state?.status === null) {
          setProgress(res.data[0]);
        }
      });

    fetch(`${constants.GetStatusHistoryUrl}/${state.applyJobId}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (state?.status !== null) {
          setStatusHistory(res.data);
        }
      });
    if (
      state?.status === "Invoice processing" ||
      state?.status === "Invoice received" ||
      state?.status === "Payment released"
    ) {
      getExisitingInvoiceDetails();
    }
  }, []);

  const handleViewJob = (jobPostId) => {
    fetch(`${constants.GetJobByIdUrl}/${jobPostId}`, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          history.push({
            pathname: "/view-job",
            state: result.data,
          });
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const downloadResume = () => {
    if (state?.applyJobId) {
      var url = `${constants.DownloadResumeUrl}/${state?.applyJobId}`;
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.blob())
        .then((response) => {
          var fileDownload = require("js-file-download");
          fileDownload(response, `${state?.cvFileName}`);
        });
    }
  };

  return (
    <Fragment>
      <div className="form-group">
        <button
          id="go-back"
          color="primary"
          className="btn btn-primary"
          style={{
            backgroundColor: "#00ADEE",
            border: "none",
            marginTop: 0,
            marginBottom: 0,
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
          type="button"
          onClick={() => backBtn()}
        >
          <i class="fa fa-arrow-circle-o-left" style={{ fontSize: "25px" }} />
        </button>
      </div>
      <div className="row">
        <div className="col-xl-5 col-xxl-5">
          <div className="row">
            <div className="col-xl-12 col-lg-6">
              <div className="card  flex-lg-column flex-md-row ">
                <div className="card-body card-body  text-center border-bottom profile-bx">
                  <div className="profile-image mb-4">
                    {/* <img src={avatar1} className='rounded-circle' alt /> */}
                  </div>
                  <p className="fs-22 text-black mb-1">{state.candidateName}</p>
                  <p className="mb-4">{state.qualification}</p>
                  <p>Organization: {state.currentOrganization}</p>
                  {loggedInUser.roles !== "Recruitment Agent" && (
                    <DropdownButton
                      id="dropdown-basic-button"
                      variant="success"
                      onSelect={handleProgress}
                      title={progress || state?.status}
                      style={{ color: "#00ADEE" }}
                    >
                      {progressList?.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item}>
                            {item}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  )}
                  <br />
                  {loggedInUser.roles === "Recruitment Agent" && (
                    <button
                      style={{
                        border: "none",
                        backgroundColor: "#00ADEE",
                        textAlign: "center",
                      }}
                      type="button"
                      className="btn btn-primary btn-md"
                      onClick={(e) => e.preventDefault()}
                    >
                      {progress || state?.status}
                    </button>
                  )}
                  <br />
                  {loggedInUser.roles === "Recruitment Agent" &&
                    (progress === "Invoice processing" ||
                      state?.status === "Invoice processing" ||
                      progress === "Invoice received" ||
                      state?.status === "Invoice received" ||
                      progress === "Payment released" ||
                      state?.status === "Payment released" ||
                      progress === "Invoice rejected" ||
                      state?.status === "Invoice rejected") &&
                    existingInvoice?.applyJob?.isInvoiceGenerated === 0 && (
                      <button
                        style={{
                          border: "none",
                          backgroundColor: "#00ADEE",
                          marginTop: "20px",
                          textAlign: "center",
                        }}
                        type="button"
                        className="btn btn-primary btn-md"
                        onClick={submitHandler}
                      >
                        <ToastContainer />
                        Generate Invoice
                      </button>
                    )}
                  {loggedInUser.roles === "Recruitment Agent" &&
                    (progress === "Invoice processing" ||
                      state?.status === "Invoice processing" ||
                      progress === "Invoice received" ||
                      state?.status === "Invoice received" ||
                      progress === "Payment released" ||
                      state?.status === "Payment released") &&
                    existingInvoice !== {} &&
                    existingInvoice?.applyJob?.isInvoiceGenerated === 1 && (
                      <button
                        style={{
                          border: "none",
                          backgroundColor: "#00ADEE",
                          marginTop: "20px",
                          textAlign: "center",
                        }}
                        type="button"
                        className="btn btn-primary btn-md"
                        onClick={submitHandler}
                      >
                        <ToastContainer />
                        View Invoice
                      </button>
                    )}
                  {loggedInUser.roles !== "Recruitment Agent" &&
                  existingInvoice !== {} &&
                  existingInvoice?.applyJob?.isInvoiceGenerated === 1 ? (
                    <button
                      style={{
                        border: "none",
                        backgroundColor: "#00ADEE",
                        textAlign: "center",
                      }}
                      type="button"
                      className="btn btn-primary btn-md"
                      onClick={viewInvoice}
                    >
                      View Invoice
                    </button>
                  ) : (
                    (progress === "Invoice processing" ||
                      state?.status == "Invoice processing" ||
                      progress === "Invoice received" ||
                      state?.status === "Invoice received" ||
                      progress === "Payment released" ||
                      state?.status === "Payment released") &&
                    loggedInUser.roles !== "Recruitment Agent" && (
                      <div>
                        <button
                          style={{
                            border: "none",
                            backgroundColor: "#00ADEE",
                            textAlign: "center",
                          }}
                          type="button"
                          className="btn btn-primary btn-md"
                          onClick={() => {
                            setIsModalOpen(true);
                          }}
                        >
                          <i className="fa fa-edit mr-2" />
                          Submit Invoice Details
                        </button>
                        <Popup
                          open={isModalOpen}
                          onClose={() => {
                            setIsModalOpen(false);
                          }}
                          position="top center"
                          closeOnDocumentClick
                          modal
                          isOpen={isModalOpen}
                          contentStyle={contentStyle}
                        >
                          <div className="col-xl-12 col-lg-12">
                            <div className="card flex-lg-column flex-md-row ">
                              <div className="card-body card-body  text-center border-bottom profile-bx">
                                <form
                                  action=""
                                  method="post"
                                  onSubmit={(e) => submitHandler(e)}
                                >
                                  <h2 className="col-form-label Description-Label">
                                    Fill Invoice details
                                  </h2>
                                  <hr />
                                  <div className="form-group row">
                                    <label className="col-lg-4 col-form-label Description-Label">
                                      Accepted CTC
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-lg-4">
                                      <input
                                        type="number"
                                        className="form-control Color-box"
                                        placeholder="Accepted CTC"
                                        defaultValue={state.userName}
                                        name="ctcAccepted"
                                        // onBlur={handleBlur}
                                        onChange={(e) =>
                                          setAcceptedCtc(e.target.value)
                                        }
                                      ></input>
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-lg-4 col-form-label Description-Label">
                                      % of CTC
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-lg-4">
                                      <input
                                        type="number"
                                        className="form-control Color-box"
                                        placeholder="% of CTC"
                                        name="percentageOfCTC"
                                        value={state?.commissionForJob}
                                        // onBlur={handleBlur}
                                        // onChange={(e) => setCtcPercent(e.target.value)}
                                      ></input>
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-lg-4 col-form-label Description-Label">
                                      Job Value
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-lg-4">
                                      <input
                                        type="number"
                                        name="jobValue"
                                        placeholder="Job Value"
                                        className="form-control Color-box"
                                        // onBlur={handleBlur}
                                        value={
                                          parseFloat(acceptedCtc) *
                                          (parseFloat(state?.commissionForJob) /
                                            100)
                                        }
                                      ></input>
                                      {/* {error.password && <span className='err'>{error.password}</span>} */}
                                    </div>
                                  </div>
                                  <div className="text-center mt-4">
                                    {isSpin ? (
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-md"
                                      >
                                        <CircularProgress
                                          color="inherit"
                                          size={24}
                                          sx={{
                                            color: "green",
                                          }}
                                        />
                                      </button>
                                    ) : (
                                      <button
                                        style={{
                                          border: "none",
                                          backgroundColor: "#00ADEE",
                                          textAlign: "center",
                                        }}
                                        type="button"
                                        className="btn btn-primary btn-md"
                                        onClick={(e) => submitHandler(e)}
                                      >
                                        Proceed for Invoice
                                      </button>
                                    )}
                                    <ToastContainer />
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </Popup>
                      </div>
                    )
                  )}
                  <br />
                  {loggedInUser.roles !== "Recruitment Agent" && (
                    <div className="form-group">
                      <label className="col-lg-6 col-form-label Description-Label">
                        Comments
                      </label>
                      <textarea
                        className="form-control Color-box"
                        placeholder="Enter comments for the status change"
                        defaultValue={state.statusComment}
                        onChange={(e) => handleComments(e)}
                        rows="2"
                        id="comment"
                        width="10px"
                      ></textarea>
                      <br />
                      <button
                        style={{
                          border: "none",
                          backgroundColor: "#00ADEE",
                          textAlign: "center",
                        }}
                        type="button"
                        className="btn btn-primary btn-md"
                        // onClick={downloadResume}
                      >
                        Cancel
                      </button>{" "}
                      &nbsp;&nbsp;
                      {isSpin ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-md"
                        >
                          <CircularProgress
                            color="inherit"
                            size={24}
                            sx={{
                              color: "green",
                            }}
                          />
                        </button>
                      ) : (
                        <button
                          style={{
                            border: "none",
                            backgroundColor: "#00ADEE",
                            textAlign: "center",
                          }}
                          type="button"
                          className="btn btn-primary btn-md"
                          onClick={saveComments}
                        >
                          Save
                        </button>
                      )}
                      <ToastContainer />
                      <h6 style={{ marginTop: 5 }}>
                        (please click the save button to save the status and
                        comment)
                      </h6>
                    </div>
                  )}
                  <br />
                  <div>
                    <h6>
                      Note: If need GST registered invoice then, please fill
                      your GST details on profile section else it will generate
                      none GST invoice
                    </h6>
                  </div>
                </div>
                <div className="card-body  border-left">
                  <div className="d-flex mb-3 align-items-center">
                    <a className="contact-icon mr-3" href="#">
                      <i className="fa fa-phone" aria-hidden="true" />
                    </a>
                    <span className="text-black">{state.mobile}</span>
                  </div>
                  <div className="d-flex mb-3 align-items-center">
                    <a className="contact-icon mr-3" href="#">
                      <i className="las la-envelope" />
                    </a>
                    <span className="text-black">{state.emailId}</span>
                  </div>
                  <div>
                    <div className="card-header">
                      <h4 className="card-title">Timeline</h4>
                    </div>
                    <div className="card-body">
                      <PerfectScrollbar
                        id="DZ_W_TimeLine"
                        className="widget-timeline dz-scroll height370 ps ps--active-y"
                      >
                        <ul className="timeline">
                          {statusHistory &&
                            statusHistory.map((status, index) => (
                              <li key={index}>
                                <div
                                  className={
                                    index <= classNames.length
                                      ? classNames[index]
                                      : classNames[
                                          Math.floor(
                                            Math.random() * classNames.length
                                          )
                                        ]
                                  }
                                ></div>
                                <div className="timeline-panel text-muted">
                                  <span>
                                    {new Date(
                                      status.statusChangedDate
                                    ).toDateString()}{" "}
                                    {new Date(
                                      status.statusChangedDate
                                    ).toLocaleTimeString()}
                                  </span>
                                  <h6 className="mb-0">
                                    Status: {status.statusName}
                                    <br />
                                    <br />
                                    <strong className="text-primary">
                                      Comment: {status.comment}
                                    </strong>
                                  </h6>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </PerfectScrollbar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-7 col-xxl-7">
          <div className="row">
            <div className="col-xl-12">
              <div className="card profile-card">
                <div className="card-header flex-wrap border-0 pb-0">
                  <h3 className="fs-24 text-black font-w600 mr-auto mb-2 pr-3">
                    {state.candidateName}
                    {"'s Profile"}
                  </h3>
                  <div className="form-group row">
                    <div className="form control">
                      {loggedInUser.roles === "Admin" && (
                        <Link
                          className="btn btn-primary btn-md"
                          style={{
                            backgroundColor: "#00ADEE",
                            textAlign: "center",
                            border: "none",
                          }}
                          to={{
                            pathname: "/apply-job",
                            state: state,
                          }}
                        >
                          <i className="fa fa-edit mr-2" />
                          Edit Candidate
                        </Link>
                      )}
                      &nbsp;&nbsp;
                      <button
                        style={{
                          border: "none",
                          backgroundColor: "#00ADEE",
                          textAlign: "center",
                        }}
                        type="submit"
                        className="btn btn-primary btn-md"
                        onClick={downloadResume}
                      >
                        <i className="fa fa-edit mr-2" />
                        Download Resume
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <form>
                    <div className="mb-sm-5 mb-2">
                      <div className="title mb-4">
                        <span className="fs-18 text-black font-w600">
                          Generals
                        </span>
                      </div>
                      <div className="col-xl-12 col-lg-12">
                        <div className="card overflow-hidden">
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Name</span>{" "}
                              <strong className="text-black">
                                {state.candidateName}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Qualification</span>{" "}
                              <strong className="text-black">
                                {state.qualification}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Experience</span>{" "}
                              <strong className="text-black">
                                {state.experienceInYears}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Relevant Experience</span>{" "}
                              <strong className="text-black">
                                {state.relevantExperience}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Organization</span>{" "}
                              <strong className="text-black">
                                {state.currentOrganization}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Location</span>{" "}
                              <strong className="text-black">
                                {state.currentLocation}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Current CTC</span>{" "}
                              <strong className="text-black">
                                {state.currentCtc}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Expected CTC</span>{" "}
                              <strong className="text-black">
                                {state.expectedCtc}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Notice Period</span>{" "}
                              <strong className="text-black">
                                {state.noticePeriod}{" "}
                              </strong>
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Ready to Relocate</span>{" "}
                              <strong className="text-black">
                                {state.readyToRelocate}{" "}
                              </strong>
                            </li>

                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Source Of Candidate</span>{" "}
                              <strong className="text-black">
                                {state.sourceOfCandidate}{" "}
                              </strong>
                            </li>

                            {state?.assessment.map((assessment, index) => (
                              <li className="list-group-item d-flex justify-content-between" key={index}>
                                <span className="mb-0">
                                  {assessment.question}
                                </span>{" "}
                                <strong className="text-black">
                                  {assessment.rating}{" "}
                                </strong>
                              </li>
                            ))}

                            <li className="list-group-item d-flex justify-content-between">
                              <span className="mb-0">Applied Jobs</span>{" "}
                              <button
                                style={{
                                  border: "none",
                                  backgroundColor: "#00ADEE",
                                  textAlign: "center",
                                }}
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleViewJob(state.jobPostId)}
                              >
                                {" "}
                                {state.jobPostId}
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default Profile;
